<template>
  <button>
    <div class="show_more_div__class d-flex justify-center">
      <div class="pt-12" @click="goToVideoPlaylistPage">
        <v-icon color="#2D8CFF" class="">mdi-arrow-right</v-icon>
        <div class="show_more_div_text__class">View all Videos</div>
      </div>
    </div>
  </button>
</template>
<script>
import ROUTER_URL from "@/constant/urls";
export default {
  name: "ShowMoreButton",
  props: {
    user_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    goToVideoPlaylistPage() {
      this.$router.push({
        name: ROUTER_URL.userPanel.children.videoAndPlaylist.name,
        query: { id: this.user_id },
      });
    },
  },
};
</script>
<style scoped>
.show_more_div__class {
  width: 250px;
  height: 147px;
  max-height: 147px;
  left: 798px;
  top: 0px;
  text-align: center;

  background: linear-gradient(0deg, #f2f8ff, #f2f8ff);
  border-radius: 12px;
}
.show_more_div_text__class {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  /* Primary */

  color: #2d8cff;
}
.align_vertically_center__class {
  margin: 0;
  position: absolute;
  top: 40%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
